import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from '../utils/analytics'

export function useAnalytics() {
  const location = useLocation()

  useEffect(() => {
    try {
      trackPageView(location.pathname)
    } catch (error) {
      // Analytics 오류는 앱 실행을 방해하지 않음
      if (import.meta.env.DEV) {
        console.warn('Analytics error:', error)
      }
    }
  }, [location.pathname])
}

